import { render, staticRenderFns } from "./RsaConfigurazioneLaboratoriRepartiViewPage.vue?vue&type=template&id=366272d4"
import script from "./RsaConfigurazioneLaboratoriRepartiViewPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneLaboratoriRepartiViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports